import axios from 'axios';

export const logsService = {
    getLogsSku: (params) => axios.get(`/logs/sku`, {auth: true, params: {...params}}),

    resolveLogsSkuById: (id) => axios.patch(`/logs/${id}`, {},{auth: true}),

    getPriceErrorsService: (params) => axios.get(`/pricer`,{auth: true, params: {...params}}),
};
